import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { createAsyncThunkSafe } from '@/state/_base/createAsyncThunkSafe';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__workspace } from '../STATE__workspace';

export const remote_workspace_user_invitation_assign_to_user = createAsyncThunkSafe<void, string>(
  ENUM__network_event_client_to_server.WORKSPACE_USER_INVITATION_ASSIGN_TO_USER,
  async (token: string): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.WORKSPACE_USER_INVITATION_ASSIGN_TO_USER, token);
  },
);

export function init_remote_workspace_user_invitation_assign_to_user(builder: ActionReducerMapBuilder<STATE__workspace>) {
  builder
    .addCase(remote_workspace_user_invitation_assign_to_user.pending, (state, action) => {})
    .addCase(remote_workspace_user_invitation_assign_to_user.rejected, (state, action) => {})
    .addCase(remote_workspace_user_invitation_assign_to_user.fulfilled, (state, action: PayloadAction) => {});
}
